import { AxiosResponse } from 'axios';
import { BUSINESS_PYTHON } from './axios';
import { config } from 'config/config.local';
import { ICategory } from 'contexts/categories/types';
import {
  ICertificationFilterOption,
  IFilterItem,
  IStatsParams,
} from 'contexts/certifications/types';

interface IGetCertifications {
  results: ICategory[];
  count: number;
}

interface ICertificationsFetchParams extends IFilterItem {
  business_account_id: string;
}

export const fetchUsersCertificationsLogs = (
  params: ICertificationsFetchParams
): Promise<AxiosResponse<IGetCertifications>> => {
  return BUSINESS_PYTHON.post(`${config.routes.certifications.logs}`, params);
};

export const fetchCertificationStats = (payload: IStatsParams): Promise<AxiosResponse<any>> =>
  BUSINESS_PYTHON.post(`${config.routes.certifications.stats}`, payload);

export const fetchCertificationFilterOptions = (
  accountId: string
): Promise<AxiosResponse<ICertificationFilterOption[]>> =>
  BUSINESS_PYTHON.get(config.routes.certifications.filterOptions(accountId));
